/**
 * Labstep
 *
 * @module components/ProtocolValue/Form/ShowEdit/ResourceItem
 * @desc ProtocolValue Info
 */

import { ProtocolValueFormShowEditResourceItemInput } from 'labstep-web/components/ProtocolValue/Form/ShowEdit/ResourceItem/Input';
import { ProtocolValueFormShowEditResourceItemOutput } from 'labstep-web/components/ProtocolValue/Form/ShowEdit/ResourceItem/Output';
import React from 'react';
import type { IProtocolValueFormShowEditResourceItemProps } from './types';

export const ProtocolValueFormShowEditResourceItem: RFC<
  IProtocolValueFormShowEditResourceItemProps
> = (props) =>
  props.protocolValue.is_output ? (
    <ProtocolValueFormShowEditResourceItemOutput {...props} />
  ) : (
    <ProtocolValueFormShowEditResourceItemInput {...props} />
  );
